import { CardUIExtension, ICardUIExtensionContext, ICardModel } from 'tessa/ui/cards';
import { Guid, createTypedField, DotNetType } from 'tessa/platform';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdUIHelper } from './CdUIHelper';
import { GridViewModel, GridRowAction } from 'tessa/ui/cards/controls';

export class CdDivisionRoleUIExtension extends CardUIExtension {

  public initialized(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.RdDivisionRoleTypeID)) {
    return;
    }

    this.IdpTeamTableHandle(context.model);
  }

  /** Логика для таблички "Паспорт проекта". */
  private IdpTeamTableHandle(model: ICardModel) {
      const idpTeamControl = CdUIHelper.GetUIControlFromModel<GridViewModel>(model, "IdpTeamControl");

      if (idpTeamControl == null) {
        return;
      }

      idpTeamControl.rowInitializing.add((e) => {
          if (e.action === GridRowAction.Inserted) {
              e.row.set("IsManualAdded", createTypedField(true, DotNetType.Boolean));
          }
      });

      // сортировки нет
      // const sortColumn = idpTeamControl.columns.find();

      // if (sortColumn != null) {
      //     sortColumn. = System.ComponentModel.ListSortDirection.Ascending;
      // }
  }
}